import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { Setup } from "../features/setup";

export const SetupPage = () => {
	return (
		<PageMeta title="施設の作成" url={PATHS.SETUP}>
			<Setup />
		</PageMeta>
	);
};
